/**
 * Legal notice — LEGALLY VALIDATED TEXT. Do not rephrase.
 *
 * Sentence-by-sentence translation of the French: transport, not
 * authoring. Structure, section order and {{...}} tokens are those of
 * `mentions-legales.fr.js`. Where the versions diverge, the French one
 * prevails — the clause at the top of the document says so.
 *
 * Belgium has no official English legal nomenclature. Belgian bodies and
 * statutes therefore keep their French name, with an English gloss on
 * first use, rather than an invented translation.
 */
const MENTIONS_LEGALES_EN = String.raw`
# Legal notice

**archer.law**
Last updated: {{DATE_MISE_EN_LIGNE}}

*This document is available in French, Dutch and English. In case of discrepancy between language versions, the French version prevails.*

## Publisher of the site

The site archer.law is published by:

**RND CONCIERGE SERVICES - FZCO**
Freezone Company incorporated under the law of the United Arab Emirates
Commercial licence no. 63620 · Dubai Integrated Economic Zones Authority (IFZA)
Registered office: DSO-IFZA, IFZA Properties, Dubai Silicon Oasis, Dubai, United Arab Emirates

**Editor in charge of publication**: Romain Debecq, manager

**Contact and personal data**: bonjour@archer.law

## Hosting

The application and the data are hosted by:

**Railway Corporation**
548 Market St, San Francisco, CA 94104, United States
railway.com

## Nature of the service

Archer is a technology platform providing legal information and legal assistance. **Archer is not a law firm** and is not registered with a bar; **Archer is not an insurance company**. The content generated by the Service constitutes legal information and does not replace consulting a lawyer. The lawyers accessible through the marketplace are independent professionals, registered with a Belgian bar, who contract directly with the client.

## Intellectual property

All elements of the site (structure, texts, graphics, logos, the Archer mascot, software) are protected by copyright and trade mark law. Any reproduction or representation, in whole or in part, without prior written authorisation is prohibited, with the exception of strictly private use and of the deliverables generated for the client under the Service.

## Reporting

To report unlawful content or unlawful use of the Service: bonjour@archer.law. We handle reports diligently.

## Disputes and mediation

The site and the services are governed by the General Terms and Conditions, which are subject to Belgian law. The consumer may refer the matter to the Consumer Mediation Service (Service de Médiation pour le Consommateur, mediationconsommateur.be, Boulevard du Roi Albert II 8 bte 1, 1000 Brussels) and to the European online dispute resolution platform: ec.europa.eu/consumers/odr.
`;

export default MENTIONS_LEGALES_EN;
